<template>
  <div class="process-node-page">
    <!-- 顶部相关描述信息 -->
    <toDescription
      v-if="$route.query.source !== 'configCenter'"
      :customers-detail="customersDetail"
      @update="getDetail"
    />
    <el-tabs
      v-if="isEdit && $route.query.source !== 'configCenter'"
      v-model="activeName"
      type="card"
      class="edit_table"
      @tab-click="handleTabClick"
    >
      <el-tab-pane label="流程配置" name="process" />
      <el-tab-pane
        label="仓配流程配置"
        name="wareHouse"
        :disabled="false"
      />
      <el-tab-pane label="全局配置" name="global" />
      <el-tab-pane label="荔途守望配置" name="litu" />
      <el-tab-pane label="AI下单配置" name="aiOrder" />
    </el-tabs>

    <!-- 新增：配置流程节点 -->
    <addConfigNode
      v-if="activeName==='process'"
      ref="addConfigNodeRef"
      :code="code"
      :customers-detail.sync="customersDetail"
      :edit-process-step="editConfigStep"
      :custom-field="CUSTOM_FIELD"
      :form.sync="form"
      :is-eidt.sync="isEidt"
      :status="status"
      :is-exist-white="isTransferGraph"
      @getConfigNodeParams="getConfigNodeParams"
      @allConfig="allConfig"
      @handleBefore="handleBefore"
      @addOrCondition="addOrCondition"
      @addAdnCondition="addAdnCondition"
      @delete="Delete"
      @OrDelete="OrDelete"
      @addTactics="addTactics"
      @addTacticsProject="addTacticsProject"
      @deleteTacticsProject="deleteTacticsProject"
    />

    <!-- 新增仓储流程配置节点 -->
    <addWareHouseConfigNode
      v-if="activeName==='wareHouse'"
      ref="addWareHouseConfigNodeRef"
      :code="code"
      :customers-detail.sync="customersDetail"
      :edit-process-step="editConfigStep"
      :custom-field="CUSTOM_FIELD"
      :form.sync="form"
      :is-edit.sync="isEditWarehouse"
      :status="status"
      :is-exist-white="isTransferGraph"
      :warehouse-config="warehouseData"
      @getConfigNodeParams="getWarehouseConfigNodeParams"
      @allConfig="allConfigWarehouse"
    />

    <!-- 新增：全局配置 -->
    <addGlobalConfig
      v-if="activeName==='global'"
      :code="code"
      :is-eidt.sync="isEidt"
      :global-config="globalData"
      :temperature="originTemperature"
      :edit-top-step="editTopStep"
      :customers-detail="customersDetail"
      @finish="finish"
    />

    <addLituConfig v-if="activeName==='litu'" :customers-detail="customersDetail" :global-config="globalData" :process-code="code" @finish="finish" />

    <addAiOrderConfig
      v-if="activeName==='aiOrder'"
      :customers-detail="customersDetail"
      @finish="finish"
    />
  </div>
</template>

<script>
import { configList } from '@/api/configure/processNode';
import { isNumber } from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import { localStorageGet } from '@/utils/localStorage';
import { getOdooAccount } from '@/api/unifyUser';
import { topSteps, specialModule } from './const';
import { flowConfigType } from './components/const';
import addConfigNode from './create/configNode.vue';
import addWareHouseConfigNode from './create/wareHouseConfigNode.vue';
import addGlobalConfig from './create/globalConfig.vue';
import toDescription from './create/topDescription.vue';
import addLituConfig from './components/addLituConfig.vue';
import addAiOrderConfig from './components/addAiOrderConfig.vue';
import { customerProcessRule, getConfigList, customerWarehouseRuleDetail } from './api';
import { getByCorp } from '../api';

export default {
  components: {
    addConfigNode,
    addWareHouseConfigNode,
    addGlobalConfig,
    toDescription,
    addLituConfig,
    addAiOrderConfig,
  },
  data() {
    return {
      topSteps,
      code: null,

      user: localStorageGet('userInfo'),
      CUSTOM_FIELD: {}, // 主要用于自定义字段配置里面
      // 整个模块的form表单，主要用于返回上一步的回显功能
      form: {
        // 流程信息
        formInfo: {
          isDefault: false,
        },
        // 创建
        CREATE_ORDER: {
          STATION_SCOPE: {
            scope: 'CUSTOMER_TENANT',
          },
          SKU_SCOPE: {
            scope: 'CUSTOMER_TENANT',
          },
          MAKEUP_TIME_CHECK: {
            flag: false,
          },
          CREATE_CUSTOM_FIELDS: {
            fields: [],
          },
          CREATE_START_TIME: {
            unit: 'DAYS',
          },
          CREATE_REACH_TIME: {
            unit: 'DAYS',
          },
          MAKEUP_START_TIME: {
            unit: 'DAYS',
          },
          MAKEUP_REACH_TIME: {
            unit: 'DAYS',
          },
          ADVANCE_PRICING: {
            flag: false,
          },
          PARENT_MARK: {
            flag: false,
          },
          CREATE_FLAG_PKG: {
            flag: false,
          },
          SKU_IGNORE_WEIGHT_VOLUME: {
            flag: false,
          },
          SKU_WEIGHT_RANGE: {},
          SKU_VOLUME_RANGE: {},
          SKU_SUM_RANGE: {},
          SKU_WEIGHT_VOLUME_RATIO: {},
          PRICING_QUOTA: {}, // 计费限额
          CREATE_NOTIFY: {
            enableNotify: false,
            notifyChannels: [],
            appointUsers: [],
            appointUserIds: [],
            weeks: [],
          },
          // INSURANCE: { // 投保规则
          //   flag: false,
          //   defaultValue: '',
          //   rules: [],
          // },
        },
        // 计费
        PRICING: {
          PRICING_CHECK: {
            flag: true,
          },
          PRICING_OVER_TIME: {
            flag: false,
          },
          PRICING_QUOTA: {},
          PRICING_CONDITION: {
            condition: [],
          },
          PRICE_STRATEGY: {
            customerCode: '',
            datas: [],
          },
          PRICING_OVER_TIME_CONDITION: {
            fieldName: 'reachTime',
            action: 'AFTER',
            unit: 'DAYS',
          },
          // TODO:
          // STAR_CONTROL: {
          //   flag: false,
          //   rules: [],
          // },
        },
        // 接单
        DEAL: {
          AUTO_DEAL: {
            flag: false,
            warehouseFlag: false,
            projectFlag: false,
          },
          DEAL_OVER_TIME: {
            flag: false,
          },
          AUTO_DEAL_CONDITION: {
            condition: [],
          },
          DEAL_OVER_TIME_CONDITION: {
            fieldName: 'reachTime',
            action: 'AFTER',
            unit: 'DAYS',
          },
          DEAL_NOTIFY: {
            enableNotify: false,
            notifyChannels: [],
            sendObject: [],
            appointUsers: [],
            appointUserIds: [],
          },
        },
        DISPATCH: {
          INSURANCE: { // 投保规则
            flag: false,
            force: false,
            defaultValue: '',
            insuranceType: 'PROJECT',
            insuranceModel: '',
            insuranceModelName: '',
            insuranceModelOrder: '',
            rules: [],
          },
          DISPATCH_OVER_TIME_CONDITION: {
            fieldName: 'reachTime',
            action: 'AFTER',
            unit: 'DAYS',
          },
          DISPATCH_OVER_TIME: {
            flag: false,
          },
          // TODO:
          STAR_CONTROL: {
            flag: false,
            rules: [],
          },
          TRANSPORT_CONTROL: {
            flag: false,
            rules: [],
          },
        },
        DRIVER_DEAL: {
          DRIVER_INSURANCE: { // 司机人险投保规则
            flag: false,
            force: false,
            defaultValue: '',
            rules: [],
          },
          DRIVER_DEAL_OVER_TIME_CONDITION: {
            fieldName: 'reachTime',
            action: 'AFTER',
            unit: 'DAYS',
          },
          DRIVER_DEAL_OVER_TIME: {
            flag: false,
          },
        },
        LOADING: {
          LOADING_OVER_TIME_CONDITION: {
            fieldName: 'reachTime',
            action: 'AFTER',
            unit: 'DAYS',
          },
          LOADING_OVER_TIME: {
            flag: false,
          },
        },
      },
      // 仓配流程配置的数据
      warehouseData: {
        orderCreateConfig: {
          inventoryCheck: true,
          flowConfig: {
            storeType: flowConfigType.sync,
            deliverType: flowConfigType.sync,
          },
        },
        orderAcceptConfig: {
          warehouseAutoAccept: true,
          projectCheck: true,
        },
        orderAssignConfig: {
          warehouseAutoAssign: true,
        },
      },

      // 全局配置的数据
      globalData: {
        globalFields: {},
        lituConfig: [],
        temperature: {},
      },
      originTemperature: {

      },
      isEdit: false,
      customersDetail: {}, // 详情
      editTopStep: -1, // 编辑返回的当前步骤(4个)
      editConfigStep: -1, // 编辑时返回的步骤(7个)
      activeName: 'process',
      status: 'DRAFT', // 当前单子的状态
      isEidt: {
        DEAL: false,
        PRICING: false,
        CREATE_ORDER: false,
        GLOBAL: false,
      },
      isEditWarehouse: false,
      isEditWarehouseKey: {
        orderCreateConfig: 'CREATE_ORDER',
        orderAcceptConfig: 'RECEIVE_ORDER',
        orderAssignConfig: 'SHIPPER_ORDER',
      },
      isExistWhite: false,
      isTranBlacklist: false,
    };
  },
  computed: {
    isTransferGraph() {
      return this.isTranBlacklist ? !this.isExistWhite : this.isExistWhite;
    },
  },
  async created() {
    // 获取相关客户配置数据
    this.getCutomConfigList();
    // 判断是否为编辑
    const { id, active } = this.$route.query;
    this.isEdit = !!id;
    this.customerId = id;
    this.editTopStep = -1;
    this.editConfigStep = -1;
    await this.getDetail();
    this.getConfig();
    this.getCustomerProcessRule();
    this.getCustomerRuleWarehouse();
    this.$nextTick(() => {
      if (active) {
        this.$refs.addConfigNodeRef.handleClick({}, Number(active));
      }
    });
  },
  methods: {
    async getDetail() {
      const res = await getByCorp({ ids: [this.customerId] });
      this.customersDetail = res.records[0] || {};
      // console.log('customersDetail', this.customersDetail);
    },
    async getConfig() {
      const keys = ['oms.assign.chain.customers', 'oms.assign.chain.customers.white.list'];
      const { configs = [] } = await getConfigList({ keys, appId: '1002' });
      const configList = {};
      configs.forEach((item) => {
        configList[item.key] = item;
      });
      const customerList = configList['oms.assign.chain.customers'].value.split(',');
      this.isExistWhite = customerList.includes(this.$route.query.code);
      this.isTranBlacklist = configList['oms.assign.chain.customers.white.list'].value === 'false';
    },

    temperatureFormatter(list) {
      return Array.isArray(list) ? list.map((item) => ({
        ...item,
        minMileage: isNumber(item.minMileage) ? `${item.minMileage}` : '',
        maxMileage: isNumber(item.maxMileage) ? `${item.maxMileage}` : '',
        minTemperature: isNumber(item.minTemperature) ? `${item.minTemperature}` : '',
        maxTemperature: isNumber(item.maxTemperature) ? `${item.maxTemperature}` : '',
      })) : null;
    },
    async getCustomerProcessRule() {
      // 获取详情接口
      const data = await customerProcessRule({
        customerCode: this.customersDetail.customerCode,
        carrierTenantId: this.customersDetail.carrierTenantId,
        assignRuleStatus: ['ENABLE', 'DISABLE'],
      });
      console.log('customerProcessRule--', data);
      const userInfo = await getOdooAccount({ login: this.user.userName });
      // 全局配置
      let globalFields = {};
      this.isEidt.GLOBAL = !!(data.currentRules && data.currentRules.length);
      if (data.currentRules && data.currentRules.some((t) => t.processModuleCode === 'GLOBAL')) {
        const GLOBAL = data.currentRules.filter((t) => t.processModuleCode === 'GLOBAL');
        globalFields = GLOBAL[0] ? GLOBAL[0].ruleValue : {};
      } else {
        const GLOBAL = data.parentRules.filter((t) => t.processModuleCode === 'GLOBAL');
        globalFields = GLOBAL[0] ? GLOBAL[0].ruleValue : {};
      }
      let temperature;
      if (data.currentRules && data.currentRules.some((t) => t.ruleCode === 'TEMPERATURE')) {
        const GLOBAL = data.currentRules.filter((t) => t.ruleCode === 'TEMPERATURE');
        temperature = GLOBAL[0] ? GLOBAL[0].ruleValue : null;
      } else {
        const GLOBAL = data.parentRules.filter((t) => t.ruleCode === 'TEMPERATURE');
        temperature = GLOBAL[0] ? GLOBAL[0].ruleValue : null;
      }
      const { dataOverviewSensitiveFields, vehicleTrackSensitiveFields, orderSensitiveFields = [] } = globalFields;
      this.originTemperature = JSON.parse(JSON.stringify(temperature));
      const {
        checkTemperature, edit, coldStorage, freezing, preCool, departure,
      } = temperature || {
        coldStorage: [{
          type: 'DEFAULT',
          minTemperature: 0,
          maxTemperature: 10,
        }],
        freezing: [{
          type: 'DEFAULT',
          minTemperature: -99,
          maxTemperature: -18,
        }],
        edit: true,
        checkTemperature: false,
      };

      // 荔途守望配置
      const lituConfig = data.currentRules.filter((item) => ['ORDER_OVERVIEW', 'EXP_ALARM', 'QUALITY_PERFORMANCE', 'CUSTOMER_PERFORMANCE_REPORT'].includes(item.ruleCode));
      console.log('🚀 ~ getCustomerProcessRule ~ lituConfig:', lituConfig);

      this.globalData = {
        globalFields: { dataOverviewSensitiveFields, vehicleTrackSensitiveFields, orderSensitiveFields },
        lituConfig,
        temperature: {
          checkTemperature,
          edit,
          coldStorage: this.temperatureFormatter(coldStorage),
          freezing: this.temperatureFormatter(freezing),
          phone: userInfo?.[0]?.workPhone,
          preCool,
          departure,
        },
      };
      const module = ['CREATE_ORDER', 'PRICING', 'DEAL', 'DISPATCH', 'DRIVER_DEAL', 'LOADING'];
      this.$set(this.customersDetail, 'parentProcessCode', data.parentRules[0].processCode);
      this.$set(this.customersDetail, 'ruleVersion', data.parentRules[0].version);
      this.$set(this.customersDetail, 'parentProcessName', data.parentProcessName);
      module.forEach((item) => {
        this.setModuleForm(data, item); // 对每个模块进行赋值
      });
      if (this.form.PRICING.PRICE_STRATEGY.datas && this.form.PRICING.PRICE_STRATEGY.datas.length) {
        const res = this.form.PRICING.PRICE_STRATEGY.datas.map((item) => {
          if (!item.projectReqs || !item.projectReqs.length) {
            return { frequencyDateConfig: { }, ...item, contractTermCodes: [item.contractReq.contractCode, item.contractReq.termCode], projectReqs: [{ projectId: '', projectName: '' }] };
          }
          return { frequencyDateConfig: { }, ...item, contractTermCodes: [item.contractReq.contractCode, item.contractReq.termCode] };
        });
        this.$set(this.form.PRICING.PRICE_STRATEGY, 'datas', res);
      }
    },
    setModuleForm(data, module) {
      if (data.currentRules && data.currentRules.some((t) => t.processModuleCode === module)) {
        const CREATE_ORDER = data.currentRules?.filter((t) => t.processModuleCode === module) || [];
        CREATE_ORDER.forEach((item) => {
          this.$set(this.form[module], item.ruleCode, item.ruleValue);
        });
        this.isEidt[module] = true;
      } else {
        const CREATE_ORDER = data.parentRules?.filter((t) => t.processModuleCode === module) || [];
        CREATE_ORDER.forEach((item) => {
          this.$set(this.form[module], item.ruleCode, item.ruleValue);
        });
        this.isEidt[module] = false;
      }
      // 单独处理二选一按钮
      if (module === 'CREATE_ORDER') {
        const list = data.parentRules.filter((t) => t.processModuleCode === module);
        const tt = list.find((t) => t.ruleCode === 'SKU_IGNORE_WEIGHT_VOLUME');
        if (tt) {
          this.$set(this.form[module], 'SKU_IGNORE_WEIGHT_VOLUME', tt.ruleValue);
        }
      }

      // 单独处理车型数据
      if (module === 'DISPATCH') {
        const list = data.currentRules.filter((t) => t.processModuleCode === module);
        const tt = list.find((t) => t.ruleCode === 'INSURANCE');
        if (tt) {
          console.log('DISPATCH--', tt);
          this.$set(this.form[module], 'INSURANCE', {
            ...tt.ruleValue,
            rules: tt?.ruleValue?.rules?.map((m) => ({
              ...m,
              value: Number(m.value),
              carType: m.carType ? m.carType.split(',') : [],
            })),
          });
        }
      }

      this.setSpecialModule(data, module);
    },
    async getCustomerRuleWarehouse() {
      // 获取详情接口
      const data = await customerWarehouseRuleDetail({
        customerCode: this.customersDetail.customerCode,
        carrierTenantId: this.customersDetail.carrierTenantId,
      });
      console.log('customerWarehouseRuleDetail--', data);
      if (data?.isDefaultConfig ?? null) {
        this.isEditWarehouse = false;
        delete data.isDefaultConfig;
      } else {
        this.isEditWarehouse = true;
      }
      this.setWarehouseModuleForm(data);
    },
    setWarehouseModuleForm(data) {
      this.warehouseData = cloneDeep(data);
    },
    setSpecialModule(data, module) {
      const sModule = specialModule[module] || [];
      sModule.forEach((item) => {
        this.$set(this.form[module], item, data.parentRules.find((rule) => rule.ruleCode === item).ruleValue);
      });
    },
    async getCutomConfigList() {
      const [res] = await configList({ key: 'process_node_create_custom_fileds' });
      const data = JSON.parse(res.value) || {};
      this.CUSTOM_FIELD = data;
    },
    handleBefore() {
      // this.activeStep = 0;
    },
    allConfig() {
      // 新增：配置节点完成，进入仓配流程配置
      // this.activeStep = 2;
      this.activeName = 'wareHouse';
    },
    allConfigWarehouse() {
      // 新增：仓配流程配置节点完成，进入全局配置
      this.activeName = 'global';
    },
    getConfigNodeParams(params) {
      const { key, formParams } = params;
      this.isEidt[key] = true;
      this.form = { ...this.form, [key]: formParams };
    },
    getWarehouseConfigNodeParams(params) {
      const { formParams } = params;
      this.isEditWarehouse = true;
      this.warehouseData = { ...this.warehouseData, ...formParams };
    },
    finish() {
      this.$router.push('/shipperSevice/setting');
    },
    handleTabClick() {
      // if (this.activeName === 'process') {
      //   this.activeStep = 1;
      // } else {
      //   this.activeStep = 2;
      // }
    },
    addOrCondition(module, ruleCode) {
      const conditionList = [...this.form[module][ruleCode].condition, [{ fieldName: '', judge: 'EQ', fieldValue: '' }]];
      this.$set(this.form[module][ruleCode], 'condition', conditionList);
    },
    addAdnCondition(index, module, ruleCode) {
      const conditionItem = [...this.form[module][ruleCode].condition[index], { fieldName: '', judge: 'EQ', fieldValue: '' }];
      this.$set(this.form[module][ruleCode].condition, index, conditionItem);
    },
    Delete(value, module, ruleCode) {
      const { index, itemIndex } = value;
      if (this.form[module][ruleCode].condition[index].length === 1) {
        this.form[module][ruleCode].condition.splice(index, 1);
        this.$set(this.form[module][ruleCode], 'condition', this.form[module][ruleCode].condition);
      } else {
        this.form[module][ruleCode].condition[index].splice(itemIndex, 1);
        this.$set(this.form[module][ruleCode].condition, index, this.form[module][ruleCode].condition[index]);
      }
    },
    OrDelete(value, module, ruleCode) {
      const { index } = value;
      this.form[module][ruleCode].condition.splice(index, 1);
      this.$set(this.form[module][ruleCode], 'condition', this.form[module][ruleCode].condition);
    },
    addTactics(module, ruleCode) {
      const tactics = [...this.form[module][ruleCode].datas, {
        projectReqs: [{ projectId: '', projectName: '' }],
        contractTermCodes: [],
        contractReq: {
          contractCode: '', contractName: '', termCode: '', termName: '',
        },
        frequencyDateConfig: { }
      }];
      this.$set(this.form[module][ruleCode], 'datas', tactics);
    },
    addTacticsProject(data, module, ruleCode) {
      const { index, prop } = data;
      this.$set(this.form[module][ruleCode].datas[index], prop, [...this.form[module][ruleCode].datas[index][prop], { projectId: '', projectName: '' }]);
    },
    deleteTacticsProject(data, module, ruleCode) {
      const { index, childIndex, prop } = data;
      this.form[module][ruleCode].datas[index][prop].splice(childIndex, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.process-node-page{
  height:100%;
  box-sizing:border-box;
  display:flex;
  flex-direction: column;
  // 顶部step
  ::v-deep .top-step{
    margin-bottom:24px;
    &.el-steps {
      .el-step {
        .el-step__head {
          .el-step__line {
            height: 1px;
            background-color: #DCDFE6;;
          }
          .el-step__icon {
            border: 2px solid #909399;
            color: #909399;
          }
          &.is-process, &.is-finish {
            .el-step__icon {
              border: 2px solid #059E84;
            }
          }
          &.is-finish {
            .el-step__icon {
              color: #059E84;
            }
            .el-step__line {
              background: #059E84;
              .el-step__line-inner {
                border: none;
              }
            }
          }
          &.is-process {
            .el-step__icon {
              background: #059E84;
              color: #FFFFFF;
            }
          }
        }
        .el-step__main {
          .el-step__title {
            color: #909399;
            &.is-finish, &.is-process {
              color: #059E84;
            }
          }
        }
      }
      .step-disable {
        .el-step__head  {
          .el-step__line {
            background-color: rgba(220, 223, 230, 0.45);;
          }
          .el-step__icon {
            border: 2px solid rgba(144, 147, 153, 0.45);
            color: rgba(143, 146, 153, 0.45);
          }
        }
        .el-step__main {
          .el-step__title {
            color: rgba(144, 147, 153, 0.45);
          }
        }
      }
    }
  }
}
::v-deep.edit_table{
  .el-tabs__header {
    margin-bottom: 0;
    border-bottom: 1px solid #e4e7ed;
    border-color: #e4e7ed;
  }
  .el-tabs__nav{
    border-color: #e4e7ed;
  }
  .el-tabs__item{
    background-color: #fff;
    border-color: #e4e7ed;
  }
}
::v-deep .el-form-item .el-form-item__label, .el-form-item .el-form-item__content{
  line-height:22px;
}
</style>
